
__webpack_require__.S = {};
__webpack_require__.initializeSharingData = { scopeToSharingDataMapping: { "default": [{ name: "@nackle/biw-web-router", version: "1.5.1", factory: () => (Promise.all([__webpack_require__.e("500"), __webpack_require__.e("3"), __webpack_require__.e("890"), __webpack_require__.e("69")]).then(() => (() => (__webpack_require__(8750))))), eager: 0 }, { name: "@nackle/bridge", version: "3.0.51", factory: () => (Promise.all([__webpack_require__.e("184"), __webpack_require__.e("890"), __webpack_require__.e("737")]).then(() => (() => (__webpack_require__(15451))))), eager: 0 }, { name: "@nackle/intl-tools", version: "1.4.85", factory: () => (Promise.all([__webpack_require__.e("405"), __webpack_require__.e("475"), __webpack_require__.e("641")]).then(() => (() => (__webpack_require__(12324))))), eager: 0 }, { name: "@nackle/origami-icons", version: "1.7.28", factory: () => (Promise.all([__webpack_require__.e("628"), __webpack_require__.e("902")]).then(() => (() => (__webpack_require__(69999))))), eager: 0 }, { name: "@nackle/umbrella-studio", version: "1.5.37", factory: () => (Promise.all([__webpack_require__.e("643"), __webpack_require__.e("890")]).then(() => (() => (__webpack_require__(1430))))), eager: 0 }, { name: "@nackle/umbrella", version: "2.1.35", factory: () => (Promise.all([__webpack_require__.e("194"), __webpack_require__.e("126")]).then(() => (() => (__webpack_require__(12945))))), eager: 0 }, { name: "antd", version: "5.29.3", factory: () => (Promise.all([__webpack_require__.e("449"), __webpack_require__.e("131"), __webpack_require__.e("303"), __webpack_require__.e("770")]).then(() => (() => (__webpack_require__(40094))))), eager: 0 }, { name: "react-dom", version: "18.3.1", factory: () => (Promise.all([__webpack_require__.e("396"), __webpack_require__.e("890")]).then(() => (() => (__webpack_require__(8143))))), eager: 0 }, { name: "react", version: "18.3.1", factory: () => (__webpack_require__.e("75").then(() => (() => (__webpack_require__(30758))))), eager: 0 }] }, uniqueName: "gantry-studio" };
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if (!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if (!initToken) initToken = initTokens[name] = {};
	if (initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if (initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if (!__webpack_require__.o(__webpack_require__.S, name))
		__webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function (msg) {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = __webpack_require__.initializeSharingData.uniqueName;
	var register = function (name, version, factory, eager) {
		var versions = (scope[name] = scope[name] || {});
		var activeVersion = versions[version];
		if (
			!activeVersion ||
			(!activeVersion.loaded &&
				(!eager != !activeVersion.eager
					? eager
					: uniqueName > activeVersion.from))
		)
			versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function (id) {
		var handleError = function (err) {
			warn("Initialization of sharing external failed: " + err);
		};
		try {
			var module = __webpack_require__(id);
			if (!module) return;
			var initFn = function (module) {
				return (
					module &&
					module.init &&
					module.init(__webpack_require__.S[name], initScope)
				);
			};
			if (module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if (initResult && initResult.then)
				return promises.push(initResult["catch"](handleError));
		} catch (err) {
			handleError(err);
		}
	};
	var promises = [];
	var scopeToSharingDataMapping = __webpack_require__.initializeSharingData.scopeToSharingDataMapping;
	if (scopeToSharingDataMapping[name]) {
		scopeToSharingDataMapping[name].forEach(function (stage) {
			if (typeof stage === "object") register(stage.name, stage.version, stage.factory, stage.eager);
			else initExternal(stage)
		});
	}
	if (!promises.length) return (initPromises[name] = 1);
	return (initPromises[name] = Promise.all(promises).then(function () {
		return (initPromises[name] = 1);
	}));
};

